import React from "react";
import "./GlassButton.css";

interface GlassButtonProps {
  variant?: "primary" | "secondary" | "neutral" | "success" | "outline";
  size?: "small" | "medium" | "large" | "icon";
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  className?: string;
}

export const GlassButton: React.FC<GlassButtonProps> = ({
  variant = "primary",
  size = "medium",
  children,
  onClick,
  disabled = false,
  type = "button",
  className = "",
}) => {
  const buttonClass = `glass-btn glass-btn-${variant} ${
    size !== "medium" ? `glass-btn-${size}` : ""
  } ${className}`;

  return (
    <button
      type={type}
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};


